// Regra de preenchimento automático da "Data de Devolução" nos boards de locação.
//
// Espelho de backend/src/helpers/locacaoDevolucao.ts. Aqui é onde acontece o
// recálculo ao trocar o tipo de locação — o usuário vê a data mudar e pode
// ajustá-la em seguida. O backend só age como rede de segurança, preenchendo
// quando o campo chega vazio (nunca sobrescreve o que já está preenchido).

export const TIPO_LOCACAO_FIELD = "campo_tipo_locacao";
export const DATA_DEVOLUCAO_FIELD = "campo_data_devolucao";

// Dias corridos somados à data de lançamento, por tipo de locação.
// ESPECIAL está ausente de propósito: não tem prazo fixo, fica manual.
export const DIAS_POR_TIPO_LOCACAO = {
  DIARIA: 1,
  SEMANAL: 7,
  QUINZENAL: 15,
  MENSAL: 30,
};

/**
 * Soma os dias do tipo de locação à data base e devolve "YYYY-MM-DD".
 * Retorna null quando o tipo não tem prazo definido (ex.: ESPECIAL) ou a base é inválida.
 */
export const calcularDataDevolucao = (tipo, baseDate) => {
  const dias = DIAS_POR_TIPO_LOCACAO[String(tipo || "").trim().toUpperCase()];
  if (dias === undefined) {
    return null;
  }

  const base = baseDate ? new Date(baseDate) : new Date();
  if (isNaN(base.getTime())) {
    return null;
  }

  // Meio-dia UTC evita que fuso horário empurre a data para o dia anterior/seguinte.
  const devolucao = new Date(
    Date.UTC(base.getFullYear(), base.getMonth(), base.getDate(), 12, 0, 0)
  );
  devolucao.setUTCDate(devolucao.getUTCDate() + dias);

  return devolucao.toISOString().split("T")[0];
};

// Tipo sem prazo fixo: é o único em que a data de devolução é digitada à mão.
export const TIPO_LOCACAO_ESPECIAL = "ESPECIAL";

/**
 * A data de devolução só é editável quando o tipo de locação é ESPECIAL.
 * Nos demais tipos ela é derivada da data de lançamento e fica travada no card.
 */
export const isDevolucaoEditavel = (tipo) =>
  String(tipo || "").trim().toUpperCase() === TIPO_LOCACAO_ESPECIAL;
